import { createAction, props } from '@ngrx/store';
import { VehicleAnalyticsFilters } from '../vehicle-analytics.models';

export const setVehicleAnalyticsFilters = createAction(
  '[Vehicle Analytics] Set Analytics Time Range',
  props<{ filters: VehicleAnalyticsFilters | null }>()
);
